import { Box, Typography } from "@mui/material";
import isNil from "lodash/isNil";
import { useMemo } from "react";
import {
  PUBLIC_MINT_COUNT_DISPLAY_THRESHOLD,
  TOTAL_PUBLIC_SUPPLY,
} from "../constants/mintConstants";

interface Props {
  nftsMinted: number | null;
}

const MintArtwork = ({ nftsMinted }: Props) => {
  const displayMintCount = useMemo(
    () =>
      !isNil(nftsMinted) && nftsMinted >= PUBLIC_MINT_COUNT_DISPLAY_THRESHOLD,
    [nftsMinted]
  );

  return (
    <Box sx={{ position: "relative" }}>
      <video width="100%" autoPlay loop muted playsInline>
        <source src="/art/tdh-placeholder.mp4" type="video/mp4" />
        Your browser does not support video playback.
      </video>
      {displayMintCount && (
        <Box
          sx={{
            position: "absolute",
            bottom: "5px",
            left: 0,
            right: 0,
            background: "#000",
            width: "200px",
            margin: "0 auto",
            padding: "7px",
            borderRadius: "10px 10px 0 0",
          }}
        >
          <Typography sx={{ fontWeight: 800, display: "inline" }}>
            {nftsMinted}
          </Typography>
          /{TOTAL_PUBLIC_SUPPLY} minted
        </Box>
      )}
    </Box>
  );
};

export default MintArtwork;
